<!-- BEGIN: Topbar -->
<!-- <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav"> -->

<div id="m_header_topbar" class="m-topbar m-stack m-stack--ver m-stack--general">
	<div class="m-stack__item m-topbar__nav-wrapper">
		<ul class="m-topbar__nav m-nav m-nav--inline">
			<!-- <m-search-dropdown *ngIf="searchType === 'search-dropdown'"></m-search-dropdown>
			<m-search-default *ngIf="searchType === 'search-default'"></m-search-default> -->
			<li id="add-catalog-link" class="float-left mr-5" style="padding-top:14px;" *ngIf="isShowroomUser() && !(isPrivateLabel() | async)">
				<a routerLink="/showroom/requests/vendors/create">
					<button class="btn btn-outline-primary">Add a new catalog</button>
				</a>
			</li>
			<li class="float-left mr-5 trial-widgets" *ngIf="isShowroomUser() || isVendorUser()">
				<span class="timer" *ngIf="(daysLeft$ | async) > 0">
					<i class="material-icons icon">timer</i>
					<span class="glowing">{{ daysLeft$ | async }} days left</span>
				</span>
				<span *ngIf="!(isPrivateLabel() | async)" class="pricing-link {{ (daysLeft$ | async) > 0 ? '' : 'no-trial' }}">
					<a [routerLink]="['/' + getModulePrefix(), 'pricing']">
						<!-- <i class="flaticon-interface-6 mr-1"></i> -->
						Plans
					</a>
				</span>
				<span class="contact-us" *ngIf="(daysLeft$ | async) > 0">
					<a href="https://www.kitchendev.com/contact/" target="_blank">
						<!-- <i class="material-icons">perm_phone_msg</i> -->
						Contact Us
					</a>
				</span>
			</li>
			<!-- <m-notification></m-notification> -->
			<!-- <m-quick-action></m-quick-action> -->
			<!-- <m-language-selector></m-language-selector> -->
			<!-- <button class="btn defaut">Logout</button> -->
			<li class="float-left mr-5" style="padding-top:19px"
				*ngIf="isShowroomUser()">
				<m-notification></m-notification>
			</li>
			<li class="float-left">
				<m-user-profile style="padding-right:30px;"></m-user-profile>
			</li>

			<!-- TODO; if layout config quick_sidebar.display is enabled -->
			<!-- <li id="m_quick_sidebar_toggle" class="m-nav__item">
				<a href="javascript:;" class="m-nav__link m-dropdown__toggle">
					<span class="m-nav__link-icon">
						<i class="flaticon-grid-menu"></i>
					</span>
				</a>
			</li> -->
		</ul>
	</div>
</div>
<!-- </div> -->
<!-- END: Topbar -->